/**
 * 驗證檔案名稱格式
 * 允許: 英文字母、中文字體、數字、空白、符號 ()_- 和 . (副檔名)
 * 不允許: 其他特殊字符
 * @returns boolean - 是否符合格式
 */
export const validateFilename = (file: File | File[]): boolean => {
  // 如果是陣列, 則檢查陣列中的每個檔案
  if (Array.isArray(file)) {
    return file.every((f) => validateFilename(f));
  }

  // 取得檔案名稱
  const filename = file.name;

  // 建立正則表達式, 驗證檔名只包含: 英文字母、中文、數字、()_-. 符號
  // \u4e00-\u9fa5 代表中文字符範圍
  const pattern = /^[a-zA-Z0-9\u4e00-\u9fa5\s()_.-]+$/;


  // 檢查是否符合格式
  return pattern.test(filename);
};

// 文件管理不限制語系及一般標點；實際儲存路徑由後端產生。
export const validateDocumentFilename = (file: File | File[]): boolean => {
  if (Array.isArray(file)) return file.every(validateDocumentFilename);
  const name = file.name;
  return name.length > 0 && name.length <= 255 && name !== '.' && name !== '..'
    && !/[\/\\\x00-\x1f\x7f]/.test(name);
};

/**
 * 取得檔案名稱（用於 FormData 上傳）
 * @returns string - 檔案名稱
 */
const filenameValidator = (file: File): string => {
  return file.name;
};

export default filenameValidator;
